<template>
<div class="mb-3">
    <div class="row">
        <div class="col-lg-12">
            <base-input alternative="" label="Contacto" input-classes="form-control-alternative" readonly v-model="contacto"/>
        </div>
        <div class="col-lg-12">
            <h3>Tipificación</h3>
            <div class="content-select-cc flex mb-2">
                <base-button size="md" block class="mr-2" type="primary" v-if="producto.nombre" @click="setProducto('producto')">{{producto.nombre}}</base-button>
                <base-button size="md" block class="mr-2 mt-0" type="info" v-if="motivo.nombre" @click="setProducto('motivo')">{{motivo.nombre}}</base-button>
                <base-button size="md" block class="mr-2 mt-0" type="warning" v-if="subMotivo.nombres" @click="setProducto('submotivo')">{{subMotivo.nombres}}</base-button>
            </div>
        </div>
        <div class="col-lg-12 mb-2" v-if="idcuenta">
            <label class="form-control-label">Cuenta</label>
            <select v-model="idcuenta" class="form-control form-control-alternative" disabled>
                <option v-for="items in allCuentas" :key="items.id" :label="items.razonsocial" :value="items.id"></option>
            </select>
        </div>
        <div class="col-lg-12" v-if="asunto">
            <base-input alternative="" label="Asunto" input-classes="form-control-alternative" readonly v-model="asunto"/>
        </div>
    </div>
</div>
</template>

<style lang="scss">
    .content-select-cc {
        border: 1px solid #cdcdcd;
        padding: 10px;
        border-radius: 5px;
        display: flex;

        .badge {
            width: 100%;
        }
    }
</style>

<script>
import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'
export default {
    props:{
        
    },
    data() {
        return {
            contacto: this.$store.getters['auth/contacto'].nombre + ' ' + this.$store.getters['auth/contacto'].apellido,
            asunto: '',
            idcuenta: null
        }
    },
    computed:{
        ...mapGetters('casos', { producto: 'producto', motivo: 'motivo', subMotivo: 'subMotivo'}),
        ...mapGetters('cuentas', { allCuentas: 'all' })
    },
    methods: {
        ...mapActions('cuentas', { getAllCuentas: 'getAll' }),
        getAll() {
            Promise.all([
                this.getAllCuentas()
            ]).then(() => {
            })
        },
        setProducto(value){
            this.$emit('setProducto', value)
        }
    },
    mounted() {
        this.getAll()
    }
}
</script>
